import { Link } from "react-router-dom";
import { BrandWordmark } from "./BrandWordmark";

function LogoFallback() {
  return (
    <BrandWordmark
      className="logo__fallback"
      typeClassName="logo__type"
      sprigClassName="logo__sprig"
    />
  );
}

export function Logo({ light = false, clean = false }: { light?: boolean; clean?: boolean }) {
  return (
    <Link
      className={`logo ${light ? "logo--light" : ""} ${clean ? "logo--clean" : ""}`}
      to="/"
      aria-label="Life's Capsule home"
    >
      <LogoFallback />
    </Link>
  );
}
